import React, { Fragment } from 'react';
import { styled } from 'dripsy';
import { View } from 'react-native';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { Icon } from '../common/Icon';
import { BaseText } from '../common/BaseText';
import { Separator } from '../common/Separator';
import { passIf } from '@utils';

const RowContainer = styled(View)({
  flexDirection: 'row',
});

const Container = styled(View)({
  minHeight: [53, 46],
  p: ['$5', '$4'],
  bg: ['$background20', '$background0'],
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 12,
  borderColor: '$primary300',
  borderWidth: [null, 1],
});

interface ITitleTextStyleProps {
  isCrossedOut?: boolean;
}

const Title = styled(BaseText)((props: ITitleTextStyleProps) => ({
  fontWeight: 'semi',
  color: '$text400',
  variant: 'text.medium',
  textDecorationLine: passIf(props.isCrossedOut, 'line-through'),
}));

const PriceText = styled(BaseText)({
  fontWeight: 'semi',
  variant: 'text.medium',
  color: '$heading800',
});

const Subtitle = styled(BaseText)({
  fontWeight: 'semi',
  color: '$text300',
  variant: 'text.xsmall',
  textAlign: 'center',
});

interface IPlanPriceViewProps {
  title: string;
  subtitle?: string;
  currentPrice: string;
  regularPrice?: string;
}

export const PlanPriceView = observer<IPlanPriceViewProps>(
  ({ title, subtitle, currentPrice, regularPrice }) => {
    const { t } = useTranslation();

    return (
      <Container>
        <RowContainer>
          <Icon name="star-bold" color="$primary300" size={20} />
          <Separator size="$2" vertical />
          <Title>
            {`${title} ${t('common.planPrice.payFor')} `}
            <Title isCrossedOut>{regularPrice}</Title>{' '}
            <PriceText>{currentPrice}</PriceText>
          </Title>
        </RowContainer>
        {!!subtitle && (
          <Fragment>
            <Separator size="$2" />
            <Subtitle>{subtitle}</Subtitle>
          </Fragment>
        )}
      </Container>
    );
  },
);
